module.exports = __webpack_public_path__ + "img/digital-signage.d4f828ce.webp";